import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumCostPriceUpdateType implements BaseEnumType {
  private static allValues: EnumCostPriceUpdateType[] = []; // make sure this is top-most
  
  public static keepCurrent = new EnumCostPriceUpdateType(0, "KeepCurrent", "enum_cost_price_update_type_keep_current");
  public static latestKnown = new EnumCostPriceUpdateType(1, "LatestKnown", "enum_cost_price_update_type_latest_known");
  public static rollingAverage = new EnumCostPriceUpdateType(2, "RollingAverage", "enum_cost_price_update_type_rolling_average");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumCostPriceUpdateType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isKeepCurrent() { return this === EnumCostPriceUpdateType.keepCurrent; }
  public isLatestKnown() { return this === EnumCostPriceUpdateType.latestKnown; }
  public isRollingAverage() { return this === EnumCostPriceUpdateType.rollingAverage; }

  public static getValues(): readonly EnumCostPriceUpdateType[] {
    return EnumCostPriceUpdateType.allValues;
  }

  public static getValuesExcept0(): readonly EnumCostPriceUpdateType[] {
    return EnumCostPriceUpdateType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumCostPriceUpdateType {
    const found = EnumCostPriceUpdateType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumCostPriceUpdateType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumCostPriceUpdateType): EnumCostPriceUpdateType {
    const found = name ? EnumCostPriceUpdateType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumCostPriceUpdateType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumCostPriceUpdateType>): boolean {
    return this.key === other?.key;
  }
}